/**
 * Утилиты для работы с состояниями соединения
 * Изолированная логика форматирования состояний
 */

import type { ConnectionState } from '../types';

/**
 * Маппинг состояний соединения на человеко-читаемый текст
 */
const CONNECTION_STATE_MAP: Record<ConnectionState, string> = {
  'new': 'Новое',
  'connecting': 'Подключение...',
  'connected': 'Подключено',
  'disconnected': 'Отключено',
  'failed': 'Ошибка',
  'closed': 'Закрыто'
};

/**
 * Преобразует состояние соединения в человеко-читаемый текст
 * @param state - Состояние соединения
 * @param isReconnecting - Флаг переподключения
 * @returns Текстовое представление состояния
 */
export function formatConnectionState(state: ConnectionState, isReconnecting: boolean = false): string {
  if (isReconnecting) {
    return 'Переподключение...';
  }
  return CONNECTION_STATE_MAP[state] || state;
}

/**
 * Маппинг типа камеры на человеко-читаемый текст
 */
const CAMERA_TYPE_MAP: Record<'front' | 'back' | 'unknown', string> = {
  'front': 'Фронтальная',
  'back': 'Задняя',
  'unknown': 'Неизвестно'
};

/**
 * Преобразует тип камеры в человеко-читаемый текст
 * @param type - Тип камеры
 * @returns Текстовое представление типа
 */
export function formatCameraType(type: 'front' | 'back' | 'unknown'): string {
  return CAMERA_TYPE_MAP[type] || 'Неизвестно';
}

